import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const MainMenu: React.FC = () => {
  const [showOptions, setShowOptions] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="flex justify-center items-center min-h-screen bg-brand-bg py-10">
      <div
        className="slide-down flex flex-col items-center justify-center w-[400px] max-w-[90%] rounded-[12px] p-8 overflow-hidden shadow-xl bg-gradient-brand"
      >
        <Helmet>
          <title>Menú | El Chel</title>
          <meta name="description" content="Elige entre el menú de mesa o el menú para llevar de El Chel. Comida yucateca en Tlalpan, CDMX." />
        </Helmet>
        <img src="/mamas/logo-s.png" alt="Logo" loading="lazy" className="w-[300px] h-auto mb-5" />
        <h1 className="text-[40px] text-white font-bold mb-5">Bienvenido 🌸</h1>

        {!showOptions && (
          <button
            onClick={() => setShowOptions(true)}
            className="py-4 px-6 text-xl bg-white text-brand-dark font-bold border-none rounded-[8px] cursor-pointer shadow-md hover:bg-brand-bg transition-colors duration-200"
          >
            Ver Menús
          </button>
        )}

        {showOptions && (
          <div className="slide-down flex flex-col items-center">
            <button
              onClick={() => navigate('/menuMesa')}
              className="py-3 px-6 text-lg bg-white text-brand-dark font-bold border-none rounded-[8px] cursor-pointer shadow-md my-2.5 hover:bg-brand-bg transition-colors duration-200"
            >
              Menú de Mesa
            </button>
            <button
              onClick={() => navigate('/menuparallevar')}
              className="py-3 px-6 text-lg bg-white text-brand-dark font-bold border-none rounded-[8px] cursor-pointer shadow-md my-2.5 hover:bg-brand-bg transition-colors duration-200"
            >
              Menú de Pedidos
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MainMenu;
